import React from 'react';
import { Checkbox, useFormContext } from 'framework/form';

const OpportunityCheckbox = ({ nameSource, label }: { nameSource: string; label: string }) => {
  const { formErrors, setFormErrors = () => {} } = useFormContext();

  const clearOpportunityValidationErrors = () => {
    const errors = { ...formErrors };

    delete errors.opportunityName;
    delete errors.closeDate;

    setFormErrors(errors);
  };

  return <Checkbox source={nameSource} label={label} clearValidationCallback={clearOpportunityValidationErrors} />;
};

export default OpportunityCheckbox;
